import React, { useState } from 'react';
import { nanoid } from '@reduxjs/toolkit';
import { isNil } from 'lodash';

import { ITeamMember } from './interfaces';
import TeamMemberCard from './TeamMemberCard';
import MemberPreviewModal from './MemberPreviewModal';
import img1 from 'assets/images/about/Cesar_Jimenez.png';
import img2 from 'assets/images/about/Jahn Karsybaev.png';
import img3 from 'assets/images/about/Rick Loss.jpg';
import img4 from 'assets/images/about/Fred Obiero.jpeg';
import img5 from 'assets/images/about/Angela Alberty.jpg';
import img6 from 'assets/images/about/Alda Davidov.jpg';
import img8 from 'assets/images/about/Rachel Stonestreet.jpg';
import img10 from 'assets/images/about/Yenlik.jpg';

import styles from './OurTeamSection.module.scss';

type ModalSettings = {
  isVisibile: boolean;
  slideIndex: number | null;
};

const initialModalSettings: ModalSettings = {
  isVisibile: false,
  slideIndex: null,
};

const teamMembers: ITeamMember[] = [
  {
    id: nanoid(),
    avatar: img1,
    name: 'Cesar Jimenez',
    position: 'CEO',
    bio: (
      <>
        <p>
          Hey there! I am Cesar A. Jimenez, CEO at myBasepay. Entrepreneur,
          Investor, military veteran and have successfully led three technology
          staffing and services organizations.
        </p>

        <p>
          As an advocate in the Contingent Workforce industry having been
          recognized with a multitude of awards for sales growth and client
          retention by staffing industry leadership. I am fiercely invested in
          both his clients and consultant’s successes and as a result has become
          a true advocate for the contingent worker. Held various leadership
          roles for both a global staffing organization and technology solutions
          companies have enabled me to develop alternative workforce models that
          provide the agility for organizations to be competitive in today’s
          marketplace.
        </p>

        <p>
          25 years of Staffing Industry expertise. Specifically, in IT staffing
          and IT solutions. VMS, MSP and EOR expertise and Recruitment
          technology expertise. I am a thought leader in TA and Staffing Tech,
          with a passion towards Contingent workforce and the way it is
          delivered.
        </p>

        <p>
          In my spare time, I enjoy spending time with my family, working out
          and coaching baseball. I am passionate about preparing and developing
          High School baseball players for their college or professional
          careers. I am an avid Podcast listener and is intensely dedicated to
          learning everything in the contingent staffing industry.
        </p>
      </>
    ),
    linkedInLink: 'https://www.linkedin.com/in/cesara-jimenez/',
  },
  {
    id: nanoid(),
    avatar: img2,
    name: 'Jahn Karsybaev',
    position: 'CIO',
    bio: (
      <>
        <p>
          Jahn had spent most of his career in technology, product and project
          management at Fortune 500 companies such as Ultimate Software, Citrix,
          Sabic and many others.
        </p>
        <p>
          He has co-founded, launched, successfully sold as well as successfully
          failed several start-ups. Fund-raising is also one of his strengths.
          Cumulatively, he has successfully raised close to $50MM for the
          startups he launched himself or advised on. Jahn is very passionate
          about mentorship and he is an Angel Investor and Board Advisor for
          several startups.
        </p>
        <p>
          Jahn is an alumnus of Harvard Business School. He is a Forbes
          contributor and council member. His podcast Ivy Podcast is an industry
          leading platform for top voices in Executive Leadership.
        </p>
        <p>
          He resides in Fort Lauderdale with his wife and 2 kids. Sports
          (basketball and boxing in particular) are his favorite sports to watch
          and play. Fun fact: he is the son of an Olympic Boxing Coach who had
          raised several Gold and Bronze Olympic Champions.
        </p>
      </>
    ),
    linkedInLink: 'https://www.linkedin.com/in/jahnibek/',
  },
  {
    id: nanoid(),
    avatar: img5,
    name: 'Angela Alberty',
    position: 'VP of Sales',
    bio: (
      <>
        <p>
          Hi there! I am Angela Alberty, VP of Business Development. My role
          consists of Operational and New Business Development opportunities at
          myBasePay.
        </p>

        <p>
          If there’s anything I am truly passionate about, its studying
          contingent workforce trends and the advocacy in representing this type
          of worker. I bring 10 years of experience in the oversight of the
          temporary workforce, including all the fun stuff needed to oversee
          this worker population successfully and compliantly on the back end.
          My background includes many implementation projects that have led to
          the contractual employment of thousands of workers. It’s an honor and
          quite an interesting space to be in! I am an expert on compliance on
          employment related matters and am here to help you run oversee all the
          details needed to have your contractor workforce running smoothly.
        </p>

        <p>
          When I’m not helping oversee contingent workers, I am a mother, wife,
          daughter, sister and aunt. I love spending time cooking up delicious
          food, doing yoga, traveling, and enjoying all the memories made with
          my family. Fun Fact:
        </p>

        <p>
          I am one of 7 children who is simultaneously a fifth generation Texan
          and First Generation American.
        </p>
      </>
    ),
    linkedInLink: 'https://www.linkedin.com/in/angela-alberty/',
  },
  {
    id: nanoid(),
    avatar: img6,
    name: 'Alda Davidov',
    position: 'Accounting Manager',
    bio: (
      <>
        <p>
          About myself:Hi, my name is Alda Davidov. I was born and raised in
          Kazakhstan. I arrived to United States back in 2007 to pursue my dream
          and here I am 14 years later happily married with 2 beautiful kids
          (boys).
        </p>
        <p>
          I am an Accounting Manager here at myBasePay, LLC to meet all your
          accounting needs, questions, or concerns. I am bringing over 13 years
          of accounting experience in hospitality, healthcare, and automotive
          industries. I started my career as an A/P Clerk in Hospitality
          Industry and growing and moving forward every day. I love what I do, I
          like challenge and I like learning every day!
        </p>
        <p>
          I love to be involved in any type of projects, such as Startup
          Companies, integration Projects, transition projects. I had an
          opportunity to participate in all listed above and I truly think that
          it is the greatest opportunity to learn every day, grow and gain the
          priceless experience. You can never learn too much.
        </p>
        <p>
          My hobby is reading, music, interior design and singing karaoke. I
          love spending time with my friends and family. I believe I have pretty
          good sense of humor, haha!
        </p>
        <p>Fun Fact: I was a Teacher of English in Kazakhstan.</p>
      </>
    ),
    linkedInLink: 'https://www.linkedin.com/in/aldanysh-davidov/',
  },
  {
    id: nanoid(),
    avatar: img3,
    name: 'Rick Loss',
    position: 'CFO',
    bio: (
      <>
        <p>
          Rick Loss is a CPA and financial professional with extensive knowledge
          in accounting, financial systems and management. With experience at
          several multi-billion dollar organizations, such as Ernst & Young,
          Republic Services, Envision Healthcare and UKG, he has developed a
          wide range of proficiencies across the financial spectrum. Using a
          collaborative approach, he has led skilled teams that maintained a
          culture committed to providing exceptional service and delivering
          results.
        </p>
        <p>
          He is excited to use his vision and financial leadership to help
          myBasePay bring value and new opportunities to contingent workers and
          those that employ them.
        </p>
        <p>
          A Florida native, Rick enjoys a variety of outdoor activities and
          spending time with family.
        </p>
      </>
    ),
    linkedInLink: 'https://www.linkedin.com/in/ricklosscpa/',
  },
  {
    id: nanoid(),
    avatar: img4,
    name: 'Fred Obiero',
    position: 'VP of Product',
    bio: (
      <>
        <p>
          Fred Obiero is an IT professional and Technology futurist who has
          thrived in implementing and leading Project Management Offices for
          companies such as Envision, Anthem, and HP. He is a published author
          of the book “The PM Imperative” and is currently the VP of Product and
          Client Engagement at MyBasePay, and an Executive Host on The Ivy
          Podcast. In his free time, Fred enjoys traveling the world, watching
          documentaries, and reading books.
        </p>
        <p>
          He is PMP-certified and holds three master’s degrees: MBA, MSMIT, and
          MSM.
        </p>
      </>
    ),
    linkedInLink: 'https://www.linkedin.com/in/fredobiero/',
  },
  {
    id: nanoid(),
    avatar: img8,
    name: 'Rachel Stonestreet',
    position: 'People Operations Manager',
    bio: (
      <>
        <p>
          I came from a smaller TX town to Houston to pursue HR bachelor’s
          degree at the University of Houston Honors College. I started my
          career in the contingent workforce supporting staffing firms with back
          office solutions and expanded the role quickly into spearheading
          contract administration and risk management as well as launching
          international and human cloud platform services.
        </p>
        <p>
          I stepped further into the HR realm and worked several years running
          an HR department for an international manufacturing business. The role
          required supporting a diverse workforce for the entire employee life
          cycle-from talent acquisition, onboarding, training, performance
          management, payroll, benefits, and terminations. Main accomplishments
          were selecting and implementing a new HRIS platform that automated and
          streamlined processes across multiple departments from warehouse
          management of time to the finance department’s reporting.
        </p>
        <p>
          I’m continually looking towards the future and staying up to date on
          the constant changes in compliance so we can use technology and people
          strategies to design the best support infrastructure for our clients.
          Once I recover from having my first child ( 2 months old ), I’ll get
          back to training MMA and tackling my never ending DIY home projects-
          I’m always focused on building things to be better at work and at home
          lol.
        </p>
      </>
    ),
    linkedInLink: 'https://www.linkedin.com/in/rastonestreet/',
  },
  {
    id: nanoid(),
    avatar: img10,
    name: 'Yenlik Baimukhanbetova',
    position: 'Technical PM',
    bio: (
      <div>
        <p>
          Yenlik is an experienced technical program manager having led system
          implementations for companies like Citrix. She is well versed in
          structuring the processes for complex system design and development,
          defining and prioritizing feature roadmaps. As a complex problem
          solver, Yenlik utilizes data & intuition to come up with creative ways
          for resolution. She holds an MBA from NSU, and is PMP certified.
        </p>
        <p>
          Yenlik is originally from Kazakhstan, having lived in New York for
          over 10 years, she now considers herself a native Floridian. She lives
          in Ft Lauderdale with her husband and 2 kids. She subscribes to vegan
          diet, loves yoga and all things mental health.
        </p>
      </div>
    ),
    linkedInLink: 'https://www.linkedin.com/in/yenlikb/',
  },
];

export default function OurTeamSection() {
  const [modalSettings, setModalSettings] = useState(initialModalSettings);

  const resetModalSettings = () => setModalSettings(initialModalSettings);

  const handlePreviewMember = (member: ITeamMember) => {
    const memberIndex = teamMembers.findIndex(({ id }) => id === member.id);

    setModalSettings({
      isVisibile: true,
      slideIndex: memberIndex,
    });
  };

  return (
    <>
      {modalSettings.isVisibile && !isNil(modalSettings.slideIndex) && (
        <MemberPreviewModal
          teamMembers={teamMembers}
          onClose={resetModalSettings}
          slideIndex={modalSettings.slideIndex}
        />
      )}

      <div className={styles.ourTeamSection}>
        <div className={styles.ourTeamWrap}>
          <h2 className="corp-title">OUR TEAM</h2>
          <div className={styles.ourTeamText}>
            Our specialists have a deep understanding of organizational
            management, labor laws and beyond. We provide consulting services
            that focus on vital issues for today's workforce, including every
            recruiting process.
          </div>
        </div>
        <div className={styles.container}>
          <div className={styles.cardGrid}>
            {teamMembers.map((member, index) => (
              <TeamMemberCard
                key={index}
                member={member}
                onPreview={handlePreviewMember}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
